import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-warning-device-admin-password',
    templateUrl: './warning-device-admin-password.component.html',
    styleUrls: ['./warning-device-admin-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarningDeviceAdminPasswordComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
